<template>
  <div class="table-container">
    <b-overlay center :show="isLoading" rounded="sm">
      <div v-if="!isLoading">
        <div v-if="ok">
          <validation-observer
            ref="observer"
            v-slot="{ invalid, handleSubmit }"
          >
            <b-form @submit.prevent="">
              <div class="form-card-wrapper">
                <b-card header-tag="header">
                  <template #header>
                    <b>Dati Identificativi</b>
                  </template>
                  <b-card-text>
                    <b-row>
                      <div class="form-group">
                        <base-select
                          :name="beForm[rep].insurer_id.label"
                          vid="insurer_id"
                          :label="beForm[rep].insurer_id.label"
                          v-model="form[rep].insurer_id"
                          :options="companies"
                          @input="onInputInsurer"
                          :rules="getRules('insurer_id')"
                        />
                      </div>
                      <div class="form-group">
                        <base-select
                          :name="beForm[rep].insurance_risk_id.label"
                          vid="insurance_risk_id"
                          :label="beForm[rep].insurance_risk_id.label"
                          v-model="form[rep].insurance_risk_id"
                          :options="products"
                          @input="onInputProducts"
                          :rules="getRules('insurance_risk_id')"
                        />
                      </div>
                      <div class="form-group">
                        <base-select
                          :name="beForm[rep].is_net.label"
                          vid="is_net"
                          :label="beForm[rep].is_net.label"
                          v-model="form[rep].is_net"
                          :options="beForm[rep].is_net.options"
                          :rules="getRules('is_net')"
                        />
                      </div>
                      <div class="form-group">
                        <base-select
                          :name="beForm[rep].is_tax.label"
                          vid="is_tax"
                          :label="beForm[rep].is_tax.label"
                          v-model="form[rep].is_tax"
                          :options="beForm[rep].is_tax.options"
                          :rules="getRules('is_tax')"
                        />
                      </div>
                      <div class="form-group">
                        <base-input
                          :name="beForm[rep].title.label"
                          vid="title"
                          :label="beForm[rep].title.label"
                          v-model="form[rep].title"
                          placeholder="Inserisci una descrizione"
                          :rules="getRules('title')"
                        />
                      </div>
                    </b-row>
                  </b-card-text>
                </b-card>
              </div>

              <div class="mt-2" v-show="customInputs[rep].length">
                <div class="form-card-wrapper">
                  <b-card header-tag="header">
                    <template #header>
                      <b>Attributi personalizzati</b>
                    </template>
                    <b-card-text>
                      <custom-inputs
                        :customInputs="customInputs[rep]"
                        v-model="form[rep]"
                        :beForm="beForm[rep]"
                        :beRules="beRules[rep]"
                      />
                    </b-card-text>
                  </b-card>
                </div>
              </div>

              <div class="form-actions form-actions--sticky">
                <div class="inner-wrapper">
                  <div>
      <span
        :title="`${
          invalid
            ? 'Compila correttamente i campi per poter salvare'
            : 'Invia il form'
        }`"
      >
        <b-button
          @click="handleSubmit(onSubmit)"
          type="button"
          :disabled="invalid"
          variant="lisaweb"
          size="sm"
          :title="`${
            invalid
              ? 'Compila correttamente i campi per poter salvare'
              : 'Invia il form'
          }`"
        >
          Salva
        </b-button>
      </span>
                    <b-button
                      @click="resetForm()"
                      class="btn--transparent btn-reset"
                      type="button"
                      title="Pulisci tutti i campi e compila il form nuovamente"
                    >Reset
                    </b-button
                    >
                  </div>
                  <div>
                    <b-button
                      @click="goBack()"
                      class="btn--transparent"
                      type="button"
                      title="Torna alla pagina precedente"
                    >
                      <b-icon-chevron-double-left
                        font-scale="0.9"
                      ></b-icon-chevron-double-left
                      >
                      Torna indietro
                    </b-button
                    >
                  </div>
                </div>
              </div>
            </b-form>
          </validation-observer>
        </div>
        <div v-else>
          {{ errorMessage }}
        </div>
      </div>
      <template #overlay>
        <div class="text-center">
          <div class="custom-loader"></div>
          <p class="loading-text">Operazione in corso...</p>
        </div>
      </template>
    </b-overlay>
  </div>
</template>

<script>
import CustomInputs from "@/components/form/CustomInputs";
import FormMixin from "@/mixins/FormMixin";
import ShortcutMixin from "@/mixins/ShortcutMixin";
import {mapGetters} from "vuex";
import BaseInput from "@/components/form/BaseInput";
import BaseSelect from "@/components/form/BaseSelect";

export default {
  mixins: [FormMixin, ShortcutMixin],
  data() {
    return {
      repository: "breakdown",
      id: this.$route.params.id,
      companies: [],
      products: [],
      form: {
        breakdown: {
          insurance_risk_id: null,
          insurer_id: null,
          is_net: null,
          is_tax: null,
          title: null,
        },
      },
    };
  },
  components: {
    CustomInputs,
    BaseInput,
    BaseSelect,
  },
  methods: {
    goBack() {
      if (this.returnUrl) {
        switch (this.returnUrl) {
          case "profile-breakdowns-edit":
            this.$router.push({
              name: "breakdowns.edit",
            });
            break;
          default:
            console.log(
              "No returnUrl set matched! Fallback to default back behavior."
            );
            this.$router.back();
            break;
        }
      } else {
        this.$router.back();
      }
    },
    onInputInsurer(insurer_id) {
      if (!this.form[this.rep].insurance_risk_id) {
        this.products = this.getProducts()(insurer_id);
      } else {
        this.form[this.rep].insurance_risk_id = null;
        this.products = this.getProducts()(insurer_id);
      }
    },
    onInputProducts(insurance_risk_id) {
      if (insurance_risk_id) {
        this.form[this.rep].insurer_id =
          this.getInsurerIdByProduct()(insurance_risk_id);
        this.products = this.getProducts()(this.form[this.rep].insurer_id);
      }
    },
    onSubmit() {
      this.isLoading = true;
      this.update(this.repository, this.id)
        .then(() => {
          this.$showSnackbar({
            preset: "success",
            text: `Azione Completata: Scorporo Modificato`,
          });
          this.shortcut("module.PROF", null, "#Breakdowns", "filterBreakdown");
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    ...mapGetters("auth", {
      getInsurers: "insurers",
      getProducts: "products",
      getInsurerIdByProduct: "insurerIdByProduct",
    }),
  },
  created() {
    this.isLoading = true;
    this.fetchEditForm(this.repository, this.id).then(() => {
      this.companies = this.getInsurers();
      this.products = this.getProducts()(
        this.beForm[this.rep].insurer_id.value
      );
      this.isLoading = false;
    });
  },
  computed: {
    rep() {
      return this.repository;
    },
  },
};
</script>
